import React from 'react';
import { Link } from 'react-router-dom';
import FadeIn from '../common/FadeIn';

const TemplateGrid = ({ templates }) => {
  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 lg:gap-8 xl:gap-10">
      {templates.map((item, index) => {
        const isComingSoon = item.category === "coming-soon";
        const isEven = (index + 1) % 2 === 0;
        const themeDemoUrl = item.externalUrl || item.demoUrl || (isEven ? "/themes/theme02/index.html" : "/themes/theme01/index.html");
        const detailsUrl = item.viewDetailsUrl || `/details/${item.slug || 'theme01'}`;

        return (
          <FadeIn key={item.id || index} className="w-full">
            <div className="w-full flex flex-col bg-white p-4 sm:p-5 rounded-[16px] border border-[#E5E0D8] shadow-2xs group transition-all duration-300 hover:shadow-sm">

              {/* Template Image Preview */}
              {isComingSoon ? (
                <div className="relative w-full aspect-[1.12/1] sm:aspect-[1.18/1] bg-[#F9F9F5] overflow-hidden rounded-[10px] sm:rounded-[12px] border border-[#E8E2D8] block cursor-default">
                  <img
                    src={item.img}
                    alt={`${item.name} Website Design Template Preview`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 ease-out"
                    loading="lazy"
                    decoding="async"
                    width="400"
                    height="320"
                  />
                  <div className="absolute inset-0 bg-black/20 backdrop-blur-[1px] flex items-center justify-center">
                    <span className="bg-white/90 text-[#1C1917] px-4 py-2 rounded-md font-montserratMedium text-[10px] uppercase tracking-[0.15em] font-bold shadow-sm">
                      Coming Soon
                    </span>
                  </div>
                </div>
              ) : (
                <a
                  href={themeDemoUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative w-full aspect-[1.12/1] sm:aspect-[1.18/1] bg-[#F9F9F5] overflow-hidden rounded-[10px] sm:rounded-[12px] border border-[#E8E2D8] block cursor-pointer"
                >
                  <img
                    src={item.img}
                    alt={`${item.name} Website Design Template Preview`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 ease-out group-hover:scale-[1.025]"
                    loading="lazy"
                    decoding="async"
                    width="400"
                    height="320"
                  />
                </a>
              )}

              {/* Action Buttons Row */}
              <div className="mt-4 sm:mt-5 w-full flex flex-row items-center gap-2.5 sm:gap-3">
                <Link
                  to={detailsUrl}
                  className="flex-1 h-[42px] sm:h-[46px] px-3 sm:px-4 border border-[#1C1917] bg-white text-[#1C1917] font-montserratMedium text-[10px] sm:text-[11px] uppercase tracking-[0.12em] font-semibold rounded-[8px] sm:rounded-[10px] flex items-center justify-center text-center cursor-pointer whitespace-nowrap hover:bg-[#1C1917] hover:text-white transition-all duration-300 shadow-2xs"
                >
                  VIEW DETAILS
                </Link>

                {isComingSoon ? (
                  <button
                    disabled
                    className="flex-1 h-[42px] sm:h-[46px] px-3 sm:px-4 bg-[#A8A196] text-white font-montserratMedium text-[10px] sm:text-[11px] uppercase tracking-[0.12em] font-semibold rounded-[8px] sm:rounded-[10px] flex items-center justify-center text-center cursor-not-allowed opacity-60 whitespace-nowrap shadow-2xs"
                  >
                    COMING SOON
                  </button>
                ) : (
                  <a
                    href={themeDemoUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 h-[42px] sm:h-[46px] px-3 sm:px-4 bg-[#0D0C0B] text-white font-montserratMedium text-[10px] sm:text-[11px] uppercase tracking-[0.12em] font-semibold rounded-[8px] sm:rounded-[10px] flex items-center justify-center text-center cursor-pointer shadow-2xs whitespace-nowrap hover:bg-[#2A2725] transition-colors duration-300"
                  >
                    LIVE DEMO
                  </a>
                )}
              </div>

            </div>
          </FadeIn>
        );
      })}
    </div>
  );
};

export default TemplateGrid;



